module.exports = __webpack_public_path__ + "fonts/GothamSSm-Book_Web.66e30a1.woff";